<template>
  <div
      class="marker-company"
      :style="style" @click="openModal">
  </div>
</template>

<script>
export default {
  name: 'ht-company-marker',
  mounted() {

  },
  props: ['color', 'company'],
  methods: {
    openModal: function () {
      this.$events.fire('open-company-modal', this.company);
    }
  },
  computed: {
    style: function () {
      return 'background-image: url(' + this.company.logo + '); border: solid 2px ' + this.color + ';';
    },
  }
};
</script>

<style lang="scss">
.marker-company {
  width: 40px;
  height: 40px;
  border-radius: 50% 50% 0 50%;
  background-color: white;
  background-position: center;
  background-size: cover;
}
</style>
